// extracted by mini-css-extract-plugin
export var wordContainer = "_ry-0";